<template>
  <div class="flex-jc-start mg-t-60 pd-r-40">
    <p class="flex-28 opacity pd-r-10 text-right">
      {{ $l('CompanySerialNo') }}
    </p>
    <div class="flex-45 pd-r-10">
      <sp-input v-model="companyInfo.serialNo" disabled type="gray" />
    </div>
    <div class="flex-25">
      <sp-input v-model="companyInfo.codeName" disabled type="gray" />
    </div>
  </div>
  <div class="flex-jc-start mg-t-2 pd-r-40">
    <p class="flex-28 opacity pd-r-10 text-right">
      {{ $l('DepartmentSerialNo') }}
    </p>
    <div class="flex-45 pd-r-10">
      <sp-input v-model="deptInfo.serialNo" disabled type="gray" />
    </div>
    <div class="flex-25">
      <sp-input v-model="deptInfo.codeName" disabled type="gray" />
    </div>
  </div>
  <div class="flex-jc-start mg-t-40 pd-r-40">
    <p class="flex-28  pd-r-10  text-right">
      {{ $l('Company&Department') }}
    </p>
    <sp-input v-model="companyDepartmentSerialNo" disabled class="flex-70" type="gray" />
  </div>
  <div class="flex-jc-start mg-t-2 pd-r-40">
    <p class="flex-28 pd-r-10 text-right">
      {{ $l('JointSerialNo') }}
    </p>
    <sp-input disabled class="flex-70" type="gray" />
  </div>

  <div class="mg-t-100 pd-l-20">
    <p v-required class="font18  text-left" style="font-weight: 600">
      {{ $l('BusinessCard') }}
    </p>
    <div class="card-fs flex-jc-bt pd-l-20 pd-r-20">
      <!-- 公司信息 -->
      <div v-if="photo" style="width: 60px" />
      <div class="flex-1 text-left">
        <p>{{ deptInfo.name }} </p>
        <!--        <p>Address : {{ deptInfo.address }}</p> -->

        <p>{{ companyInfo.name }}</p>
        <!--        <p>Address : {{ companyInfo.address }}</p> -->
        <p>Head/Group : {{ masterNodeDefaultCorp.name }}</p>
        <!--        <p>{{ masterNodeDefaultCorp.city?.name }}  {{ masterNodeDefaultCorp.country?.name }}</p> -->
      </div>
    </div>
    <div class="card-fs flex-jc-bt pd-l-20 pd-r-20">
      <div v-if="photo" style="width: 60px">
        <img style="width: 40px; margin-top: 14px" :src="photo">
      </div>
      <div class="flex-1 text-left">
        <p class="">Email : {{ deptInfo.emails }}</p>
        <p>
          TEL(REP) :
          <span v-if="deptInfo.telRepMain">
            {{ telCode }} {{ deptInfo.telRepMain }}
          </span>
        </p>
        <p>
          TEL(DIR) :
          <span v-if="deptInfo.telDirMain">
            {{ telCode }} {{ deptInfo.telDirMain }}
          </span>
        </p>
        <p>
          Fax :
          <span v-if="deptInfo.faxMain">
            {{ telCode }} {{ deptInfo.faxMain }}
          </span>
        </p>
        <p>Skype : {{ deptInfo.skype }}</p>
        <p>Other Contacts : {{ deptInfo.others }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import spInput from '@/components/common/SpInput'
import spIcon from '@/components/common/SpIcon'
import spCard from '@/components/common/SpCard'
export default {
  name: 'DeptOtherInfo',
  nameSpace: 'company.AddDepartment',
  components: {
    spInput,
    spIcon
  },

  props: {
    deptInfo: {
      type: Object,
      default () {
        return {}
      }
    },

    // 部门对应的公司信息
    companyInfo: {
      type: Object,
      default () {
        return {}
      }
    },

    // 部门对应集团公司
    masterNodeDefaultCorp: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  computed: {
    companyDepartmentSerialNo () {
      let str = ''
      if (this.deptInfo.serialNo && this.masterNodeDefaultCorp.serialNo) {
        str = this.masterNodeDefaultCorp.serialNo + '-' + this.companyInfo.serialNo + '-' + this.deptInfo.serialNo
      }
      if (this.deptInfo.serialNo && !this.masterNodeDefaultCorp.serialNo) {
        str = this.companyInfo.serialNo + '-' + this.deptInfo.serialNo
      }
      return str
    },

    jointSerialNo () {
      return this.deptInfo.serialNo ? this.masterNodeDefaultCorp.serialNo + '-' + this.companyInfo.serialNo + '-' + this.deptInfo.serialNo : null
    },

    telCode () {
      return this.deptInfo.cityCode ? `+ ${this.deptInfo.countryCode} ${this.deptInfo.cityCode}` : `+ ${this.deptInfo.countryCode}`
    },

    photo () {
      return this.deptInfo.photo ? Object.values(this.deptInfo.photo)[0] : ''
    }
  }
}
</script>

<style scoped lang="less">
.mg-t-2{
  margin-top: 2px;
}
.opacity{
  opacity: 0.7;
}
.card-fs {
  font-size: 12px;
}
</style>
